import { render, staticRenderFns } from "./videoplayer.vue?vue&type=template&id=3ab3e1b8&scoped=true"
import script from "./videoplayer.vue?vue&type=script&lang=js"
export * from "./videoplayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab3e1b8",
  null
  
)

export default component.exports